<template>
  <div class="simple-measures-page">
    <div class="measures-header">
      <h1 class="main-title">玉溪市教育资源配置应对举措</h1>
      <div class="subtitle">前瞻规划 · 精准施策 · 动态调整</div>
    </div>

    <div class="measures-content">
      <!-- 主要做法标题 -->
      <div class="title-section">
        <div class="title-decoration"></div>
        <h2 class="measures-main-title">主要做法</h2>
        <div class="title-decoration"></div>
      </div>

      <!-- 做法一：建立健全人口与教育动态监测预警机制 -->
      <div class="measure-section">
        <div class="measure-header">
          <div class="measure-number">（一）</div>
          <h3 class="measure-title">建立健全人口与教育动态监测预警机制</h3>
        </div>

        <div class="measure-content">
          <!-- 数据共享与监测 -->
          <div class="initiative">
            <h4 class="initiative-title">跨部门数据共享与动态监测：</h4>
            <p class="initiative-content">
              与
              <span class="highlight-location">公安、卫健、统计等部门</span>
              建立常态化数据共享机制，建成统一的
              <span class="highlight-target">学龄人口数据库与动态监测平台</span>
              ，实现
              <span class="highlight-action">"一月一更新、一季一分析"</span>
              ，精准测算各学段学龄人口变化，
              <span class="highlight-result">提前3—5年发布学位供需、教师配置预警信号</span>
              。
            </p>
          </div>

          <!-- 分析报告与决策支持 -->
          <div class="initiative">
            <h4 class="initiative-title">深度分析报告与决策支持：</h4>
            <p class="initiative-content">
              完成
              <span class="highlight-target">
                《玉溪市人口变化对教育资源配置影响的深度分析报告》
              </span>
              ，为
              <span class="highlight-action">学校布局、师资调配</span>
              提供科学依据，实现从
              <span class="highlight-principle">被动应对到主动适应</span>
              的人口趋势转变。
            </p>
          </div>
        </div>
      </div>

      <!-- 做法二：系统谋划"十五五"规划，调整学校布局 -->
      <div class="measure-section">
        <div class="measure-header">
          <div class="measure-number">（二）</div>
          <h3 class="measure-title">系统谋划"十五五"规划，调整学校布局</h3>
        </div>

        <div class="measure-content">
          <!-- 布局原则与方向 -->
          <div class="initiative">
            <h4 class="initiative-title">优化布局原则与方向：</h4>
            <p class="initiative-content">
              遵循"
              <span class="highlight-principle">合理布局、适度超前、够用适用、均衡发展</span>
              "原则，将学校布局纳入
              <span class="highlight-target">"十五五"规划</span>
              ，重点加强
              <span class="highlight-location">红塔区中心城区和各县（市、区）城区所在地</span>
              的学校资源配置。
            </p>
          </div>

          <!-- 撤并与新建规划 -->
          <div class="initiative">
            <h4 class="initiative-title">撤并与新建规划：</h4>
            <p class="initiative-content">
              规划
              <span class="highlight-action">撤并薄弱学校188所</span>
              （其中：初中9所，小学95所）； 在人口集中区域
              <span class="highlight-action">新建高中1所，初中2所、小学4所，幼儿园10所。</span>
            </p>
            <p class="initiative-content">
              通过
              <span class="highlight-model">"一校一案"精准扩容</span>
              解决城区学位短期紧张问题。
            </p>
          </div>

          <!-- 空间格局优化 -->
          <div class="initiative">
            <h4 class="initiative-title">教育空间格局优化：</h4>
            <p class="initiative-content">
              基本实现
              <span class="highlight-result">
                小学向乡镇集中，初中向县城集中，高中向县城或主城区集中
              </span>
              的分布格局，促进教育资源
              <span class="highlight-principle">集约化、高效化</span>
              配置。
            </p>
          </div>
        </div>
      </div>

      <!-- 做法三：精准施策，优化资源配置和项目建设 -->
      <div class="measure-section">
        <div class="measure-header">
          <div class="measure-number">（三）</div>
          <h3 class="measure-title">精准施策，优化资源配置和项目建设</h3>
        </div>

        <div class="measure-content">
          <!-- 师资精准配置 -->
          <div class="initiative">
            <h4 class="initiative-title">师资精准配置与优化：</h4>
            <p class="initiative-content">
              建立
              <span class="highlight-mechanism">教师资源库</span>
              ，加强区域、学段间师资共享； 畅通
              <span class="highlight-action">骨干教师向乡村学校、薄弱学校流动</span>
              的渠道； 探索建立
              <span class="highlight-model">区域"走教制"服务网络</span>
              ，破解乡村学校"
              <span class="highlight-target">开齐开足开好课</span>
              "难题； 完善
              <span class="highlight-reform">教师退出与转型机制</span>
              ，加强转岗培训。
            </p>
          </div>

          <!-- 项目建设投入 -->
          <div class="initiative">
            <h4 class="initiative-title">重点项目建设与投入：</h4>
            <p class="initiative-content">
              "十五五"期间规划投入
              <span class="highlight-target">159.42亿元</span>
              ，实施
              <span class="highlight-action">教育项目188个</span>
              ，包括
              <span class="highlight-detail">义务教育优质均衡发展项目101个</span>
              、
              <span class="highlight-detail">改善普通高中办学条件项目24个</span>
              、
              <span class="highlight-detail">学前教育发展项目24个</span>
              等。
            </p>
          </div>

          <!-- 办学模式创新 -->
          <div class="initiative">
            <h4 class="initiative-title">办学模式创新：</h4>
            <p class="initiative-content">
              通过
              <span class="highlight-model">集团化办学、学区制管理、城乡教育共同体</span>
              等模式，统筹利用各学段资源，
              <span class="highlight-action">以强校带弱校、城校带乡校</span>
              ，促进师资、课程、管理经验共建共享。
            </p>
          </div>

          <!-- 闲置资源盘活 -->
          <div class="initiative">
            <h4 class="initiative-title">闲置校园校舍盘活利用：</h4>
            <p class="initiative-content">
              联合多部门出台
              <span class="highlight-target">闲置校园校舍资源盘活指导意见</span>
              ，建立
              <span class="highlight-mechanism">"信息共享、分工负责、齐抓共管"</span>
              的工作格局，将"
              <span class="highlight-result">沉睡资产</span>
              "转化为服务教育、公益和乡村振兴的有效资源。
            </p>
          </div>
        </div>
      </div>

      <!-- 下步打算 -->
      <div class="measure-section measure-section-blue">
        <div class="measure-header">
          <div class="measure-number">下步打算</div>
        </div>

        <div class="measure-content">
          <div class="initiative">
            <p class="initiative-content" style="font-size: 20px; line-height: 1.8">
              立足人口变化趋势，优化教育资源配置本质上是
              <span class="highlight-target">教育公平问题</span>
              。下一步，我们将教育资源布局深度融入
              <span class="highlight-location">人口发展战略全局</span>
              ，以系统的规划、创新的机制和精准的政策，
              <span class="highlight-action">推动教育从"人人有学上"向"人人上好学"迈进</span>
              ，构建起与
              <span class="highlight-principle">人口长期均衡发展相协调</span>
              、与
              <span class="highlight-target">中国式现代化玉溪篇章相匹配</span>
              的高质量教育体系。
            </p>
          </div>
        </div>
      </div>

      <!-- 总结部分 -->
      <div class="summary-section">
        <div class="summary-content">
          <p class="summary-text">
            通过建立健全监测预警机制、系统规划学校布局、精准优化资源配置三大举措，
            玉溪市正积极应对学龄人口变化挑战，推动教育资源从
            <span style="font-weight: 700; color: #1976d2">刚性供给、静态配置</span>
            向
            <span style="font-weight: 700; color: #388e3c">弹性适应、动态优化</span>
            转变，为区域教育高质量发展奠定坚实基础。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 不需要复杂脚本
</script>

<style scoped>
.simple-measures-page {
  padding: 24px;
  background: linear-gradient(135deg, #fdfcfb 0%, #e4eaf5 100%);
  min-height: 100vh;
  font-family: 'Microsoft YaHei', 'Segoe UI', 'PingFang SC', sans-serif;
}

.measures-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px 20px;
  background: linear-gradient(135deg, #9c27b0 0%, #673ab7 100%);
  border-radius: 12px;
  color: white;
  box-shadow: 0 8px 25px rgba(156, 39, 176, 0.3);
}

.main-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 12px;
  line-height: 1.3;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.subtitle {
  font-size: 18px;
  opacity: 0.9;
  font-weight: 400;
}

.measures-content {
  max-width: 80%;
  margin: 0 auto;
}

.title-section {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  gap: 20px;
}

.title-decoration {
  flex: 1;
  height: 3px;
  background: linear-gradient(90deg, transparent, #673ab7, transparent);
}

.measures-main-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin: 0;
  padding: 0 20px;
}

.measure-section {
  background: white;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  border-left: 5px solid #673ab7;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.measure-section-blue {
  border-left: 5px solid #1976d2;
  background: linear-gradient(135deg, #f8fdff 0%, #f0f9ff 100%);
}

.measure-section:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.measure-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.measure-number {
  font-size: 26px;
  font-weight: 700;
  color: #673ab7;
  margin-right: 15px;
  min-width: 60px;
}

.measure-section-blue .measure-number {
  color: #1976d2;
}

.measure-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.measure-content {
  font-size: 18px;
  line-height: 1.8;
  color: #444;
}

.initiative {
  margin-bottom: 30px;
  padding-bottom: 25px;
  border-bottom: 1px solid #f0f0f0;
}

.initiative:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.initiative-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #ff9800;
}

.initiative-content {
  font-size: 18px;
  line-height: 1.7;
  color: #444;
  text-align: justify;
}

.highlight-target {
  font-weight: 700;
  color: #d32f2f;
  background-color: #ffebee;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-location {
  font-weight: 600;
  color: #7b1fa2;
  background-color: #f3e5f5;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-action {
  font-weight: 600;
  color: #1976d2;
  background-color: #e3f2fd;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-result {
  font-weight: 700;
  color: #388e3c;
  background-color: #e8f5e9;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-principle {
  font-weight: 700;
  color: #f57c00;
  background-color: #fff3e0;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-detail {
  font-weight: 600;
  color: #5d4037;
  background-color: #efebe9;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-model {
  font-weight: 600;
  color: #00796b;
  background-color: #e0f2f1;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-example {
  font-weight: 700;
  color: #c2185b;
  background-color: #fce4ec;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-reform {
  font-weight: 600;
  color: #0288d1;
  background-color: #e1f5fe;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-mechanism {
  font-weight: 600;
  color: #5d4037;
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-program {
  font-weight: 600;
  color: #d84315;
  background-color: #fbe9e7;
  padding: 2px 6px;
  border-radius: 4px;
}

.summary-section {
  margin-top: 40px;
  padding: 30px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 10px;
  border-left: 5px solid #1976d2;
}

.summary-content {
  text-align: center;
}

.summary-text {
  font-size: 20px;
  line-height: 1.8;
  color: #1565c0;
  font-weight: 500;
  margin: 0;
  text-align: center;
}

@media (max-width: 768px) {
  .simple-measures-page {
    padding: 15px;
  }

  .measures-header {
    padding: 20px 15px;
    margin-bottom: 25px;
  }

  .main-title {
    font-size: 26px;
  }

  .measures-main-title {
    font-size: 24px;
  }

  .measure-section {
    padding: 20px;
    margin-bottom: 20px;
  }

  .measure-title {
    font-size: 20px;
  }

  .measure-content,
  .initiative-content {
    font-size: 17px;
  }

  .initiative-title {
    font-size: 18px;
  }

  .summary-section {
    padding: 20px;
  }

  .summary-text {
    font-size: 18px;
  }

  .title-section {
    flex-direction: column;
    gap: 10px;
  }

  .title-decoration {
    width: 100%;
  }
}
</style>
